import { Card } from "@jti/core-components/components/Card";
import type { ICurrencyEnum } from "@jti/magento";
import { useSelector } from "@jti/store/reduxHooks";
import { Txt, useTranslations } from "@jti/ui";
import LoyaltyLogo from "@jti/ui/icons/loyalty_logo.svg";

import { LOYALTY_CHOICE, useLoyalty } from "@checkout/hooks/useLoyalty";

import { CheckoutLoyaltyPointsToggle } from "./components/CheckoutLoyaltyPointsToggle";

export const CheckoutLoyaltyPoints = () => {
  const { __ } = useTranslations();
  const loyaltyData = useLoyalty();

  const currency = useSelector((store) => store.cart.currency.code as ICurrencyEnum);

  return (
    <div className={"checkout-loyalty-points"} data-testid="checkoutLoyaltyPoints">
      <Card variant="level-2">
        <div className={"checkout-loyalty-points__title"}>
          <Txt variant={"txt-7"} className={"checkout-loyalty-points__title-field"}>
            {__("loyalty.pointsBlock.title")}
          </Txt>
          <LoyaltyLogo height={"25px"} width={"42px"} />
        </div>
        <div className={"checkout-loyalty-points__balance"}>
          <Txt variant={"txt-3"} className={"checkout-loyalty-points__balance-text"}>
            {__("loyalty.pointsBlock.balance")}
          </Txt>
          <div className={"checkout-loyalty-points__balance-value"}>
            <Txt
              variant={"txt-7"}
              className={"checkout-loyalty-points__balance-value-text"}
              dataTestId="checkoutPoints"
            >
              {loyaltyData.userPoints}
            </Txt>
            {loyaltyData.loyaltyChoice === LOYALTY_CHOICE.COLLECT && (
              <Txt variant={"small-text"} dataTestId="checkoutUpcomingPoints">
                {__("loyalty.pointsBlock.upcomingPoints", [loyaltyData.cartPoints])}
              </Txt>
            )}
          </div>
        </div>

        <CheckoutLoyaltyPointsToggle {...loyaltyData} currency={currency} />
      </Card>
    </div>
  );
};
